export class UrlHelper {
  static removeLocalePrefix(path: string): string {
    const localePrefixes = ['et', 'es', 'pt'];
    const pathParts = path.split('/');
    if (localePrefixes.includes(pathParts[1])) {
      return '/' + pathParts.slice(2).join('/');
    }
    return path;
  }
}
